import { render, staticRenderFns } from "./WeixinShare.vue?vue&type=template&id=0ef786e8&scoped=true&"
import script from "./WeixinShare.vue?vue&type=script&lang=js&"
export * from "./WeixinShare.vue?vue&type=script&lang=js&"
import style0 from "./WeixinShare.vue?vue&type=style&index=0&id=0ef786e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef786e8",
  null
  
)

export default component.exports